import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Dashboard,
    name: "Dashboard"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
